import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findCouponRules = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/coupon-rules?` + params,
        method: 'GET'
    })
}
export const addCouponRules = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon-rules`,
        method: 'POST',
        data: data
    })
}
export const updateCouponRules = (data) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon-rules`,
        method: 'PUT',
        data: data
    })
}
export const deleteCouponRules = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon-rules/${id}`,
        method: 'DELETE'
    })
}
export const findProvince = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province`,
        method: 'GET',
    })
};
export const findCities = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
        method: 'GET',
    })
};
export const findAreas = (id) => {
    return request({
        url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
        method: 'GET',
    })
};
export const findProductCoupon = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/coupon/all`,
        method: 'GET',
    })
};